
import {of as observableOf,  Observable } from 'rxjs';

import {map, filter, withLatestFrom, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AnnouncementInterface, OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import * as actions from '../actions/index';
import * as selectors from '../reducers/index';

export const dashboardRegex = /^\/organisations\/[a-z0-9-]+$/;
@Injectable()
export class AnnouncementEffects {
  @Effect()
  getAnnouncementList = this.actions$
    .ofType(actions.Announcements.REQUEST_ALL).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, org]) => {
      return this.organisationApi
        .getAnnouncement(org)
        .map((payload: AnnouncementInterface[]) =>
          actions.Announcements.ResponseSuccessAllAction(payload)
        )
        .catch(err => observableOf(actions.Announcements.ResponseFailAction(err)));
    }),);

  @Effect()
  refreshStatistics = this.actions$
    .ofType(actions.Organisations.SELECT_BY_ID).pipe(
    withLatestFrom(this.store.select(selectors.getRouterState)),
    filter(
      ([action, router]) => (router && router.state ? dashboardRegex.test(router.state.url) : false)
    ),
    map(action => actions.Announcements.RequestAllAction),);

  constructor(
    private store: Store<any>,
    private actions$: Actions<actions.CAAction>,
    private organisationApi: OrganisationsApi
  ) {}
}
